import {
  Component,
  OnInit,
  Directive,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { DataService } from "../../../../@core/utils/data.service";
import { DialogAttributeComponent } from "../dialog-attribute/dialog-attribute.component";
import { SettingCallFlowsComponent } from "../setting-callflows/setting-callflows.component";

@Component({
  selector: "language-editing-list",
  templateUrl: "./language-editing.component.html",
  styleUrls: ["./language-editing.component.scss"],
})
export class LanguageEditingComponent implements OnInit {
  @Input() isReadOnly: any = false;
  @Input() isAllowDesign: any = false;
  @Output() openSetting = new EventEmitter<any>();
  selectedItem: any;
  variableList: any;
  searchText: string = "";
  languages = [];
  constructor(
    public dataService: DataService,
    public dialogService: NbDialogService
  ) {}

  ngOnInit() {
    this.selectedItem = this.dataService.flowLanguage;
    this.languages = JSON.parse(this.dataService.CallSetting.languageSetting);
  }
  filterVariable() {
    let languageSetting = JSON.parse(
      this.dataService.CallSetting.languageSetting
    );
    this.languages = languageSetting.filter((attribute) => {
      return (
        attribute.name?.toLowerCase().includes(this.searchText.toLowerCase()) ||
        attribute.content?.toLowerCase().includes(this.searchText.toLowerCase())
      );
    });
  }
  clickedRow(item) {
    this.selectedItem = item.split("-")[0];
    this.dataService.flowLanguage = item.split("-")[0];
  }
  showSetting() {
    this.openSetting.emit(true);
  }
}
